import { useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import loadSavedSearches from 'ha/modules/SavedSearches/actions/loadSavedSearches';
import { getUserId } from 'ha/modules/AuthLogic/selectors';
import { useIntl } from 'ha/i18n';
import { SearchBarProps } from 'ha/modules/SearchBar/types';
import { getInitialItems } from 'ha/modules/SavedSearches/selectors';
import { City } from 'ha/services/apiV2/types/City';

import { getLocation, getCitiesNearby } from '../selectors';

const useSearchBar = () => {
  const { T, lang } = useIntl();

  const userId = useSelector(getUserId);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!userId) {
      return;
    }
    dispatch(loadSavedSearches(userId, { language: lang }));
  }, []);

  const location = useSelector(getLocation);
  const citiesNearby: City[] | undefined = useSelector(getCitiesNearby);
  const initialItems = useSelector(getInitialItems);

  const searchBarProps = useMemo(() => {
    let initialSuggestions: SearchBarProps['initialSuggestions'] =
      initialItems.length > 0 ? initialItems : [];

    if (
      initialSuggestions.length === 0 &&
      citiesNearby &&
      citiesNearby.length > 0
    ) {
      initialSuggestions = [
        {
          id: 'nearby-cities',
          label: T('search_bar_nearby_cities'),
          disabled: true,
        },
        ...citiesNearby.map(city => ({
          id: city.cityName,
          label: `${city.cityName}, ${city.countryName}`,
        })),
      ];
    }

    return {
      initialValue: location,
      initialSuggestions,
    };
  }, [location, citiesNearby, initialItems]);

  return searchBarProps;
};

export default useSearchBar;
